import React from 'react';
import { useLang } from '@/i18n/LanguageContext';
import { Container, SectionHeading, SectionKicker, TricolourRibbon } from '@/components/common/Layout';
import { AgendaGrid } from '@/components/sections/AgendaGrid';
import { Card, CardContent } from '@/components/ui/card';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function AgendaPage() {
  const { t } = useLang();
  return (
    <div>
      <section className="hero-surface">
        <Container className="py-14 sm:py-16">
          <SectionKicker>{t('nav.agenda')}</SectionKicker>
          <h1 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#0B1220]">
            {t('agenda.title')}
          </h1>
          <p className="mt-4 max-w-3xl text-[#5B6B82] text-base leading-relaxed">{t('agenda.lede')}</p>
        </Container>
      </section>

      <section className="py-14">
        <Container>
          <AgendaGrid />

          <Card className="mt-12 border-[#D7E1EF] bg-white">
            <CardContent className="p-6 sm:p-8 grid grid-cols-1 lg:grid-cols-12 gap-6 items-center">
              <div className="lg:col-span-8">
                <SectionKicker>{t('common.motto')}</SectionKicker>
                <div className="font-display mt-3 text-2xl font-semibold text-[#0B1220]">
                  Every priority. One time-bound plan.
                </div>
                <p className="mt-3 text-sm text-[#5B6B82] max-w-2xl">
                  Each of these priorities is backed by a manifesto topic with published principles, actions, success measures and a timeline.
                </p>
              </div>
              <div className="lg:col-span-4 flex flex-col sm:flex-row lg:flex-col gap-3 lg:items-end">
                <Link to="/manifesto">
                  <Button className="bg-[#062B5C] text-white hover:bg-[#05244d]" data-testid="agenda-manifesto-cta">{t('manifesto.title')}</Button>
                </Link>
                <Link to="/vision">
                  <Button variant="outline" className="border-[#D7E1EF] text-[#062B5C]" data-testid="agenda-vision-cta">{t('nav.vision')}</Button>
                </Link>
              </div>
            </CardContent>
          </Card>
        </Container>
      </section>

      <TricolourRibbon />
    </div>
  );
}
